import classNames from 'classnames';
import { faPlus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ToggleBtnProps {
  isActive: boolean;
  canToggle: boolean;
  onToggle: () => void;
  label: string; // Label for the button (e.g., "Title", "Description")
}

export const ToggleBtn: React.FC<ToggleBtnProps> = ({
  isActive,
  canToggle,
  onToggle,
  label,
}) => {
  if (!canToggle) return null; // Don't render the button if toggling is not allowed

  return (
    <button
      type="button"
      onClick={onToggle}
      className={classNames(
        styles.default,
        isActive ? styles.active : styles.inactive,
      )}
    >
      {isActive ? (
        <>
          <span>{label}</span>
          <FontAwesomeIcon icon={faXmark} className={styles.icon} />
        </>
      ) : (
        <>
          <FontAwesomeIcon icon={faPlus} className={styles.icon} />
          <span>{label}</span>
        </>
      )}
    </button>
  );
};

const styles = {
  default: classNames(
    'inline-flex items-center gap-1 py-1 px-2.5 border rounded-full text-xs',
    'focus:outline-hidden',
  ),
  inactive:
    'bg-surface-card text-ink-secondary border-stroke hover:bg-surface-field',
  active:
    'bg-accent-tint text-accent-tint-ink font-medium border-accent-tint-ink/30',
  icon: 'text-[9px]',
};
